import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=601cc738"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports